/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import { Link, useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router'
import {
  fetchData,
  getEncryptedRoute,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import Swal from 'sweetalert2'
import { Tr } from '../../../_metronic/i18n/Tr'

const HotelDetailsHeader: React.FC = () => {
  let t = Tr()
  const { menuId, menuIdEdit, menuIdDelete } = useMenuIdPermissions()
  const tmp = sessionStorage.getItem('admin')
  const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

  const location = useLocation()
  const hotelId = (location.state as any)?.hotelId || ''
  const [hotelDetails, setHotelDetails] = useState([]) as any
  const [data, setData] = useState('')
  const [selected, setSelected] = useState('')
  const navigate = useNavigate()

  // hotel Details api call
  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: hotelId,
    }
    var response: any = await fetchData('vendor/public/hotelDetails', param)

    if (response.status == '200') {
      var data = response.data
      const isElegant = Number(data[0]?.['elegant'] ?? 0) === 1
      const isTraditional = Number(data[0]?.['traditional'] ?? 0) === 1
      if (isElegant && isTraditional) {
        setSelected('hotelboth')
      } else if (isElegant) {
        setSelected('hotelelegant')
      } else if (isTraditional) {
        setSelected('hoteltraditional')
      } else {
        setSelected('none')
      }

      setHotelDetails(data)
    } else {
      toasterrormsg(response.message)
    }
  }

  // open reject conformation
  const rejectconfirmation = async (status: any, id: any) => {
    Swal.fire(
      status == '2'
        ? {
          title: t('Are You Sure? You Want to Reject This Accommodation Document.'),
          icon: 'warning',
          showCancelButton: true,
          input: 'text',
          inputLabel: 'Reason',
          inputPlaceholder: t('Enter Reject Reason'),
          inputValidator: (value) => {
            // Validate input here
            if (!value) {
              return t('Reject Reason Required!')
            }
            if (value.length > 150) {
              return t('Reject Reason cannot exceed 150 characters!')
            }
          },
        }
        : {
          title: t('Are You Sure? You Want to Approve This Accommodation Document.'),
          icon: 'warning',
          showCancelButton: true,
        }
    ).then(async (result) => {
      if (result.isConfirmed) {
        const inputValue = result.value
        if (status == '1') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'hotel',
            adminId: adminId,
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/approverejecthotel', dataObj)

          if (res.status === 200) {
            Swal.fire({
              title: t('Status Change Successfully !'),
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                hotelDetailsApiCall()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              icon: 'error',
            })
          }
        } else if (inputValue !== undefined && inputValue.trim() !== '' && status == '2') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'hotel',
            adminId: adminId,
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/approverejecthotel', dataObj)

          if (res.status === 200) {
            Swal.fire({
              title: t('Status Change Successfully !'),
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                hotelDetailsApiCall()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              icon: 'error',
            })
          }
        } else {
          // If input value is not valid, show error message
          Swal.fire({
            title: t('Invalid Input!'),
            text: t('Please enter a valid reason.'),
            icon: 'error',
          })
        }
      }
    })
  }
  useEffect(() => {
    hotelDetailsApiCall()
    document.title = "Insayr | Hotel Overview"

  }, [])

  const confirmdelete = (hotelId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          hotelId: hotelId,
          adminId: adminId,
        }

        var res = await fetchData('vendor/public/deleteHotel', param)

        if (res.status == '200') {
          navigate(getEncryptedRoute('../viewhotels/', { menuId: menuId }))
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }

  const hotelElegantApiCall = async () => {
    var tmp2 = sessionStorage.getItem('admin')
    // Step 2: Check if the item is not null
    if (tmp2) {
      // Step 3: Parse the JSON string
      var adminData = JSON.parse(tmp2)
      // Step 4: Access the adminId
      var adminId = adminData.adminId
    }
    var param: any = {
      id: hotelId,
      categoryId: '1',
      isTraditional: data === 'hoteltraditional' || data === 'hotelboth' ? '1' : '0',
      isElegant: data === 'hotelelegant' || data === 'hotelboth' ? '1' : '0',
      adminId: adminId,
    }

    var response: any = await fetchData('admin/iselegant', param)

    if (response.status == '200') {
      toastsuccessmsg('Saved Successfully')
      hotelDetailsApiCall()
    } else {
      toasterrormsg('Something Went Wrong')
    }
  }
  return (
    <>
      {hotelDetails.map((hotel: any, index: any) => {
        var imageUrl = ''
        var totalImage = ''
        if (hotel['images'].length != 0) {
          imageUrl = hotel['images'][0].mediaPath
          totalImage = '+' + (hotel['images'].length - 1)
        } else {
          imageUrl = toAbsoluteUrl('/media/avatars/300-1.jpg')
          totalImage = ''
        }
        return (
          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {totalImage ? (
                      <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white d-flex justify-content-center align-items-center fw-bold fs-4'>
                        {totalImage}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>{hotel['en_name']}</div>

                        <button className='btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3'>
                          {hotel['subcategory'][0] ? hotel['subcategory'][0]['en_name'] : ''}
                        </button>
                      </div>

                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                        <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                          <KTIcon iconName='sms' className='fs-4 me-1' />
                          {hotel['email']}
                        </div>
                        <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                          <KTIcon iconName='phone' className='fs-4 me-1' />
                          {hotel['mobileNumber']}
                        </div>
                        <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                          <KTIcon iconName='geolocation' className='fs-4 me-1' />
                          {hotel['location']}
                        </div>
                      </div>
                    </div>
                    <div className='mt-5'>
                      {hotel['businessInfostatus'] == 0 && (
                        <>
                          {menuIdEdit ? (
                            <button
                              className='btn btn-success btn-sm me-3'
                              onClick={() => {
                                rejectconfirmation('1', hotel['hotelId'])
                              }}
                            >
                              {t('Approve')}
                            </button>
                          ) : (
                            ''
                          )}
                          {menuIdEdit ? (
                            <button
                              className='btn btn-danger btn-sm me-3'
                              onClick={() => {
                                rejectconfirmation('2', hotel['hotelId'])
                              }}
                            >
                              {t('Reject')}
                            </button>
                          ) : (
                            ''
                          )}

                        </>
                      )}
                      {menuIdDelete ? (
                        <button
                          className='btn btn-sm me-3'
                          style={{ backgroundColor: 'orange', color: 'white' }}
                          onClick={() => confirmdelete(hotel['hotelId'])}
                        >
                          {t('Delete')}
                        </button>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>

                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'>
                        <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{hotel['roomList'].length}</div>
                          </div>

                          <div className='fw-bold fs-6 text-gray-400'>{t('Room Count')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-8 my-3'>
                {/* Label */}
                <label className='fs-4 form-label d-block mb-3'>
                  {t('Is Accommodation Elegant Or Traditional?')}
                </label>

                {/* Options */}
                <div className='d-flex flex-wrap gap-4'>
                  <div className='my-2'>
                    <label className='d-flex align-items-center' data-kt-button='true'>
                      <input
                        className='form-check-input me-3'
                        type='radio'
                        name='isElegant'
                        value='hotelelegant'
                        checked={data ? data === 'hotelelegant' : selected === 'hotelelegant'}
                        onClick={() => setData('hotelelegant')}
                      />
                      <span className='fs-5 fw-bold text-gray-800'>{t('Elegant')}</span>
                    </label>
                  </div>
                  <div className='my-2'>
                    <label className='d-flex align-items-center' data-kt-button='true'>
                      <input
                        className='form-check-input me-3'
                        type='radio'
                        name='isElegant'
                        value='hoteltraditional'
                        checked={data ? data === 'hoteltraditional' : selected === 'hoteltraditional'}
                        onClick={() => setData('hoteltraditional')}
                      />
                      <span className='fs-5 fw-bold text-gray-800'>{t('Traditional')}</span>
                    </label>
                  </div>
                  <div className='my-2'>
                    <label className='d-flex align-items-center' data-kt-button='true'>
                      <input
                        className='form-check-input me-3'
                        type='radio'
                        name='isElegant'
                        value='hotelboth'
                        checked={data ? data === 'hotelboth' : selected === 'hotelboth'}
                        onClick={() => setData('hotelboth')}
                      />
                      <span className='fs-5 fw-bold text-gray-800'>{t('Both')}</span>
                    </label>
                  </div>
                  <div className='my-2'>
                    <label className='d-flex align-items-center' data-kt-button='true'>
                      <input
                        className='form-check-input me-3'
                        type='radio'
                        name='isElegant'
                        value='none'
                        checked={data ? data === 'none' : selected === 'none'}
                        onClick={() => setData('none')}
                      />
                      <span className='fs-5 fw-bold text-gray-800'>{t('None')}</span>
                    </label>
                  </div>
                </div>

                {/* Save Button */}
                {menuIdEdit && (
                  <div className='mt-3'>
                    <button className='btn btn-success' onClick={() => hotelElegantApiCall()}>
                      {t('Save')}
                    </button>
                  </div>
                )}
              </div>

              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/hoteloverview/' && 'active')
                      }
                      to={getEncryptedRoute('../hoteloverview/', { menuId: menuId })}
                      state={{ hotelId: hotelId }}
                    >
                      {t('All Details')}
                    </Link>
                  </li>

                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/viewroomslist/' && 'active')
                      }
                      to={getEncryptedRoute('../viewroomslist/', { menuId: menuId })}
                      state={{ hotelId: hotelId }}
                    >
                      {t('Rooms')}
                    </Link>
                  </li>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/viewaccommodationcontract/' && 'active')
                      }
                      to={getEncryptedRoute('../viewaccommodationcontract/', { menuId: menuId })}
                      state={{ hotelId: hotelId, vendorId: hotelDetails[0].vendorId }}
                    >
                      {t('Contract')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export { HotelDetailsHeader }
